import React from "react";
import moment from "moment";
import { Technology } from "../../../../../../redux/slices/projects/Types";
import { getTechnologyBadgeVariant } from "../../../../../../utils/technologyBadge";
import "./ProjectDetailsBanner.scss";

type ProjectDetailsBannerProps = {
  projectName: string;
  lastUpdated: string;
  technologies: Technology[];
  activeTechnology: string;
  onTechnologyChange: (technology: string) => void;
};

const ProjectDetailsBanner: React.FC<ProjectDetailsBannerProps> = ({
  projectName,
  lastUpdated,
  technologies,
  activeTechnology,
  onTechnologyChange,
}) => {
  return (
    <div className="project-details-banner">
      <div className="project-details-banner__top">
        <div className="project-details-banner__text">
          <h1 className="project-details-banner__title">
            Solution Overview - {projectName}
          </h1>
          <p className="project-details-banner__subtitle">
            View and manage project solution
          </p>
        </div>
        <div className="project-details-banner__meta">
          <span className="project-details-banner__meta-label">LAST UPDATED</span>
          <span className="project-details-banner__meta-value">{moment(lastUpdated, "MMM DD YYYY - hh:mm A").format("DD MMM YYYY - hh:mm A")}</span>
        </div>
      </div>

      {technologies.length > 0 ? (
        <div className="project-details-banner__tabs">
          {technologies.map((technology) => {
            const variant = getTechnologyBadgeVariant(technology.technology);
            const isActive = activeTechnology === technology.technology;

            return (
              <button
                key={technology.technology_id}
                type="button"
                className={`project-details-banner__tab project-details-banner__tab--${variant}${
                  isActive ? " project-details-banner__tab--active" : ""
                }`}
                onClick={() => onTechnologyChange(technology.technology)}
              >
                {technology.technology}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default ProjectDetailsBanner;
